<template>
	<div class="page-container">
		<md-dialog-alert
	      :md-active.sync="alert"
	      :md-content="msgAlert"
	      md-confirm-text="Ok" />
		<md-app md-mode="fixed">
			<md-app-toolbar class="md-primary">
				<md-button class="md-icon-button" @click="backHome()">
					<md-icon>arrow_back</md-icon>
				</md-button>
				<span class="md-title" style="font-size: 15px; font-weight: bold;text-overflow: ellipsis;white-space: nowrap;overflow: hidden;max-width: 240px; margin-left: 0;">
					Login
				</span>
			</md-app-toolbar>
			<md-app-content>
				<div class="fundo-geral" style="height: 100%;">
					<div class="md-layout">
						<div class="md-layout-item logo">
							<img class="titan-logo" src="../assets/titan_logo.png">
						</div>
					</div>
					<div class="md-layout">
						<div class="md-layout-item" style="padding-left: 10px; padding-right: 10px; margin-top: 10px;">
							<md-field>
						      <label>Usuário</label>
						      <md-input v-model="usuario"></md-input>
						    </md-field>
						    <md-field>
						      <label>Senha</label>
						      <md-input v-model="senha" type="password"></md-input>
						    </md-field>
						    <md-button class="md-raised md-primary" style="width: 95%;" @click="login()">ENTRAR</md-button>
						</div>
					</div>
				</div>
			</md-app-content>
		</md-app>
	</div>
</template>
<script>

	import axios from 'axios'

	export default {
		name: 'TitanLogin',
		data () {
			return {
				usuario: "",
				senha: "",
				alert: false,
			    msgAlert: ""
			}
		},
        methods: {
        	backHome: function() {
        		this.$router.push({ name: 'TitanHome'})
        	},
        	login: function() {
        		if (this.usuario == "" || this.senha == "") {
        			this.msgAlert = "Preencha usuário e senha."
        			this.alert = true
        			return false;
        		}

        		var jsonLogin = {};
        		jsonLogin.username = this.usuario
        		jsonLogin.password = this.senha

        		var form = new FormData();
				form.append("data", JSON.stringify(jsonLogin));
				var config = {
				  headers: {'Content-Type': 'application/x-www-form-urlencoded'}
				};

				var v = this;
				axios({
				    method: 'post',
				    url: this.$root.$data.API_URL + 'seller/login',
				    data: form,
				    config: config
			    })
			    .then(function (response) {
			        // console.log(response);
		        	let result = response.data
		        	if (!(result.success)) {
		        		v.msgAlert = result.message
	        			v.alert = true
	        			return false;
		        	}

		        	v.$store.commit('LOGIN_SUCCESS', result)

		        	v.backHome()
				});
        	}
        },
        mounted() {
		}
	}
</script>

<style lang="scss" scoped>
@import "~vue-material/dist/theme/engine"; // Import the theme engine

@include md-register-theme("default", (
	primary: #000000, // The primary color of your brand
	accent: #CB1323 // The secondary color of your brand
	));

@import "~vue-material/dist/theme/all"; // Apply the theme

.logo {
	text-align: center;
	margin-top: 10px;
}

</style>


// WEBPACK FOOTER //
// src/components/TitanLogin.vue